export default {
  supportedLngs: ["en"],
  fallbackLng: "en",
  defaultNS: "common",
  resources: {},
  react: { useSuspense: false },
};
